var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 56,
    height: 56,
    rx: 8,
    fill: "#FBD9A8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 32.5c.5.5 6.5 8.2 12.6 11.6 2 1 3 2.2 5.3 2.4 3 .3 4.8-.6 7.2-2.4 2.8-2.1 4-4.3 4.8-7.7 1-4-1.8-6.5-1-10.6 1.2-5.8 2.4-5.8 1.5-7.7-.5-1-.8-1-1.5-1-1.4 0-2.8 1.1-3.8 2.4-1.3 1.7.3 2.8-1 4.4l-1.4 2-13-14c-.5-.5-1.3-.4-2 0s-1 1-1 1.9c0 1 8.3 12 8.3 12L20 13.8c-.5-.5-2.4-1-3.4 0-.9.9 0 3.3 0 3.3l11.1 13-11-10c-.3-.3-1.4-.5-2 0-.7.5-.5 1.9 0 2.3l10.6 13-6.7-5.7c-.5-.5-2.2-1.1-3-.5-.8.7 0 2.9.5 3.3Z",
    fill: "#E79829"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6 11.4s2 1.6 3 2.9a16 16 0 0 1 1.5 3.3M33 9s2.2 1.3 3.3 2.8c1.4 1.8 2.5 5.8 2.5 5.8M12.4 33.5s1 2.3 2.2 3.4c1 1 3 2.1 3 2.1m-7.9-4.6s.9 2.5 2.1 3.9c1.6 1.7 5.2 3.5 5.2 3.5",
    stroke: "#774600",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.5cda1c368baccba7ed7f9c551df00134.svg";
export { ForwardRef as ReactComponent };